exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__ProfileInfo__inner {\n  display: block;\n}\n\n  .DS__ProfileInfo__inner > * {\n    margin-bottom: 24px;\n  }\n\n  .DS__ProfileInfo__inner > *:last-child {\n      margin-bottom: 0;\n    }\n\n  .DS__ProfileInfo__inner_without_status_block {\n    margin-top: -7px;\n  }\n\n.DS__ProfileInfo__links {\n  display: block;\n}\n\n.DS__ProfileInfo__priority_list {\n    display: block;\n    padding-right: 20px;\n    padding-left: 20px;\n    margin-bottom: 16px;\n  }\n\n.DS__ProfileInfo__priority_item {\n    display: block;\n    margin-bottom: 15px;\n  }\n\n.DS__ProfileInfo__priority_item:last-child {\n      margin-bottom: 0;\n    }\n\n.DS__ProfileInfo__logout {\n  display: flex;\n  padding: 16px 20px 4px;\n}\n\n.DS__ProfileInfo__logout_without_links {\n    padding-top: 20px;\n  }\n\n.DS__ProfileInfo__logout_button {\n    width: 120px;\n  }\n\n.DS__ProfileInfo__inner .DS__ProfileInfo__links .DS__ProfileInfo__link {\n  padding-right: 20px;\n  padding-left: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"inner": "DS__ProfileInfo__inner",
	"inner_without_status_block": "DS__ProfileInfo__inner_without_status_block",
	"links": "DS__ProfileInfo__links",
	"priority_list": "DS__ProfileInfo__priority_list",
	"priority_item": "DS__ProfileInfo__priority_item",
	"logout": "DS__ProfileInfo__logout",
	"logout_without_links": "DS__ProfileInfo__logout_without_links",
	"logout_button": "DS__ProfileInfo__logout_button",
	"link": "DS__ProfileInfo__link"
};